import MUIDataTable from 'mui-datatables';
import React, { Component } from 'react'
import { Link } from "react-router-dom";
import withRouter from "../../withRouter.js";
// 
import { userid } from '../../Common/Credentials.js';
import { spin } from '../../Common/NewLoader.jsx';
import CustomToolbar from '../../CommonComponents/CustomToolbar.js';
import Header from '../../Component/Header.js';
import Menu from '../../Component/Menu.js';
import { ThemeProvider, Tooltip } from "@mui/material";
import { createTheme } from "@mui/material";
import MasterService from '../MasterService.js';

import deleteIcon from "../../images/Icons/delete.png";
import Breadcrumb from '../../NewUI/NewComponents/Breadcrumb.jsx';

const theme = createTheme({
  overrides: {
    MuiTableCell: {
      head: {
        backgroundColor: "#e9ecef !important",
        border: [[1, 'solid', '#ece6e6']],
      },
      body:
      {
        border: [[1, 'solid', '#ece6e6']],
      },
    },
  },
});


class StatesTable extends Component {


  constructor(props) {
    super(props)

    this.state = {
      message: '',
      statesdata: [],
      loading: false,

    }
    // this.refreshCustomer=this.refreshCustomer.bind(this)
    // this.deleteColour=this.deleteColour.bind(this)
  }



  DeleteState(id) {
    MasterService.DeleteState(id)
      .then(() =>
        MasterService.getAllStates()
          .then(response =>
            this.setState({ statesdata: response.data }),
            this.setState({ message: "State Deleted Successfully" })
          )
      )
      .catch((e) => {
        if (e.response.data.error === "Unauthorized") {
          alert("Your Session is Lost: Please login Back to resume");
          this.props.navigate(`/`);
        }
      })

  }


  refresh() {
    MasterService.getAllStates()
      .then(
        response => {
          this.setState({ statesdata: response.data })
          this.setState({ loading: false })
        }
      )
      .catch((e) => {
        if (e.response.data.error === "Unauthorized") {
          alert("Your Session is Lost: Please login Back to resume");
          this.props.navigate(`/`);
        }
      })
  }

  componentDidMount() {

    if (userid === undefined) {
      window.confirm('Your Session is Lost: Please login Back to resume')
      this.props.navigate(`/`)
    }

    //   UserService.UserPermissions(userid).then(response=>this.setState({up:response.data}))

    this.setState({ loading: true })

    this.refresh();

  }

  render() {

    const columns = [
      { name: "id", label: "Id", options: { filter: false, sort: true, display: false } },
      { name: "name", label: "State", options: { filter: false, sort: true, } },
      { name: "country", label: "Country", options: { filter: true, sort: true, } },
      {
        name: "Delete",
        options: {
          filter: false,
          sort: false,
          empty: true,
          customBodyRender: (value, tableMeta, updateValue) => {

            return (
              <span
                role="button"
                tabIndex={0}
                onClick={() => {
                  if (
                    window.confirm(
                      `Are you sure you wish to delete Colour ${tableMeta.rowData.find((e) => e)}?`
                    )
                  )
                    this.DeleteState(tableMeta.rowData.find((e) => e));
                }}
                onKeyPress={(e) => {
                  if (e.key === "Enter") {
                    if (
                      window.confirm(
                        `Are you sure you wish to delete Colour ${tableMeta.rowData.find((e) => e)}?`
                      )
                    )
                      this.DeleteState(tableMeta.rowData.find((e) => e));
                  }
                }}
                style={{ cursor: "pointer" }}
              >
                <Tooltip title="Delete">
                  <img
                    src={deleteIcon}
                    alt="Delete"
                    style={{ width: "1.3rem", height: "1.3rem" }}
                  />
                </Tooltip>
              </span>
            );

          },
        },
      },
    ];
    const options = {
      filterType: 'checkbox',
      selectableRows: "none",
      customToolbar: () => {
        return (<>

          <Link as="button" className="float-right btn btn-sm m-0 p-0" to={{ pathname: "/addstate" }}>
            <CustomToolbar />
          </Link>
        </>
        );
      }
    }
    return (
      <div>
        <Header />
        <Menu />
        <div className="content-wrapper">
        <div className="UI-container">
          <div className='UI-card'>
        <div className={`UI-header`}>
          <Breadcrumb breadcrumbs={[{name:"Home",path:"/superadminmasters"},{name:"States",path:null}]}/>
        </div>
            <div className="UI-table-container">
                      <div className="text-center">{this.state.loading === true ? spin : ''}</div>
                      <ThemeProvider theme={theme}>
                        <MUIDataTable
                          className="table-sm"
                          title={"States"}
                          data={this.state.statesdata}
                          columns={columns}
                          options={options}
                        />
                      </ThemeProvider>
                    </div>
                    </div>
          </div>
        </div>
      </div>

    )

  }

}
export default withRouter(StatesTable)